// The Classic sidebar's Collections section, collapsible like a category (its state kept with the categories' on
// this device, under COLLECTIONS_KEY). Collapsed, it still shows the open collection, and its label says how many
// there are.

/** The section's key among the collapsed categories; category ids are ULIDs, so none can be this. */
export const COLLECTIONS_KEY = "collections";

/** The collections the section lists. */
export function shownCollections<T extends { id: string }>(all: readonly T[], collapsed: boolean, open: string | null | undefined): T[] {
  return collapsed ? all.filter((l) => l.id === open) : [...all];
}

/** The section's label: "Collections", or "Collections (3)" while collapsed. */
export const collectionsLabel = (count: number, collapsed: boolean) => (collapsed && count ? `Collections (${count})` : "Collections");

/**
 * Whether Collections is collapsed for this server on this device, as the Classic sidebar keeps it (its categories'
 * map, `bloom:collapsed:<serverId>`). The server menu's Collections (the Chats layout, or Classic with Collections
 * turned off in its list) reads and writes the same flag.
 */
export function collectionsCollapsed(serverId: string): boolean {
  try {
    return !!JSON.parse(localStorage.getItem(`bloom:collapsed:${serverId}`) ?? "{}")[COLLECTIONS_KEY];
  } catch {
    return false;
  }
}

export function setCollectionsCollapsed(serverId: string, collapsed: boolean) {
  try {
    const key = `bloom:collapsed:${serverId}`;
    const map = JSON.parse(localStorage.getItem(key) ?? "{}");
    localStorage.setItem(key, JSON.stringify({ ...map, [COLLECTIONS_KEY]: collapsed }));
  } catch {
    // private mode: it just won't be remembered
  }
}
